<template>
    <div class="slide trivia-15">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="1"
                    :total="5"
                    :selectAll=true
                    :className="className" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-16",
            className: "trivia-15",
            currentTrivia: 15,
            questions: {
                question: {
                    "title": "What should be your goal in an interview with a subject?",
                    "answers": [
                        {"key": "A", "answer": "Get a confession of guilt"},
                        {"key": "B", "answer": "Find out how much they have stolen"},
                        {"key": "C", "answer": "Learn where they have been selling stolen merchandise"},
                        {"key": "D", "answer": "Gain intelligence that can further be investigated to expand the case"}
                    ],
                    "correctAnswer": ["C", "D"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-15 {
    padding: 20px 35px;

    h1 {
        font-size: 24px;
        line-height: 1.5;
    }
}
</style>
